import {
  PROFILE_KEY,
  NICKNAME_KEY,
} from '../../types/profile.types'

export default function () {
  return {
    [PROFILE_KEY]: null,
    [NICKNAME_KEY]: null,
  }
}
